import React, { useEffect, useState } from "react";
import Logo from "../assets/logo_lite.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "animate.css";
import "../assets/css/util.css";
import "../assets/css/main.css";
import VanillaTilt from "vanilla-tilt";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { authService } from "../services/auth.service";
import { useNavigate } from "react-router-dom";

const Login = () => {
  useDocumentTitle("Login Dashboard");
  const navigate = useNavigate();

  useEffect(() => {
    const tiltElement = document.querySelector(".js-tilt") as HTMLElement;
    if (tiltElement) {
      VanillaTilt.init(tiltElement, {
        max: 25,
        speed: 400,
        scale: 1.1,
      });
    }
  }, []);

  const [showValidation, setShowValidation] = useState({
    username: false,
    password: false,
  });

  const validate = (name: string) => {
    const input = document.querySelector(
      `input[name="${name}"]`
    ) as HTMLInputElement;
    if (!input.value) {
      const validateDiv = input.parentElement;
      if (validateDiv) {
        validateDiv.setAttribute(
          "data-validate",
          `${name === "username" ? "Username" : "Password"} is required`
        );
        validateDiv.classList.add("alert-validate");
      }
      setShowValidation((prev) => ({ ...prev, [name]: true }));
    }
  };

  const hideValidate = (name: string) => {
    const input = document.querySelector(
      `input[name="${name}"]`
    ) as HTMLInputElement;
    const validateDiv = input.parentElement;
    if (validateDiv) {
      validateDiv.classList.remove("alert-validate");
    }
    setShowValidation((prev) => ({ ...prev, [name]: false }));
  };

  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const username = form.username.value;
    const password = form.password.value;

    if (!username) validate("username");
    if (!password) validate("password");

    if (username && password) {
      try {
        const response = await authService.login({ username, password });
        navigate("/dashboard");
      } catch (error) {
        console.error("Login failed:", error);
        setErrorMessage("Login failed.");
      }
    }
  };

  const handleFocus = (name: string) => {
    hideValidate(name);
  };

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  return (
    <div className="limiter">
      <div className="container-login100">
        <div className="wrap-login100">
          <div className="login100-pic js-tilt">
            <img src={Logo} alt="IMG" />
          </div>

          <form className="login100-form validate-form" onSubmit={handleSubmit}>
            <span className="login100-form-title">Login Dashboard</span>

            {/* Alert Bootstrap */}
            {errorMessage && (
              <div className="alert alert-danger" role="alert">
                {errorMessage}
              </div>
            )}

            <div
              className={`wrap-input100 validate-input ${
                showValidation.username ? "alert-validate" : ""
              }`}
              data-validate="Username is required"
            >
              <input
                className="input100"
                type="text"
                name="username"
                placeholder="Username"
                onFocus={() => handleFocus("username")}
                autoComplete="off"
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-user" aria-hidden="true"></i>
              </span>
            </div>

            <div
              className={`wrap-input100 validate-input ${
                showValidation.password ? "alert-validate" : ""
              }`}
              data-validate="Password is required"
            >
              <input
                className="input100"
                type={passwordVisible ? "text" : "password"}
                name="password"
                placeholder="Password"
                onFocus={() => handleFocus("password")}
                autoComplete="off"
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-lock" aria-hidden="true"></i>
              </span>
              <button
                type="button"
                className="btn-show-password"
                onClick={togglePasswordVisibility}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  opacity: 0.5,
                }}
              >
                <i
                  className={`fa ${
                    passwordVisible ? "fa-eye-slash" : "fa-eye"
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
            </div>

            <div className="container-login100-form-btn">
              <button type="submit" className="login100-form-btn">
                Login
              </button>
            </div>

            <div className="text-center p-t-12"></div>
            <div className="text-center p-t-136"></div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
